import React from 'react';
import withCommonEMContainer from '../_commons/CommonEMContainer';
import useStyles from '@front10/helpers/dist/UseStyles';

import { getAirports as getAirportsFn } from '../../../_integrations/everymundo/airports';
import { getSubscription } from '../../../_integrations/everymundo/subscription.js';

// import { useTrackingChange } from '../../../_integrations/everymundo/tracking/index';

import Skeleton from '../../others/Skeleton/SkeletonNewsletter';
import useFilters from './hook/filters';
import ImageHeader from '../../elements/ImageHeader';
import HeaderContainer from '../../elements/HeaderContainer';
import ContainerErrorAlert from '../../alerts/ContainerErrorAlert';
import Form from './Form';
import Row from '../../elements/Row';
import Col from '../../elements/Col';
import Box from '../../elements/Box';
import Button from '../../elements/Button';
import Text from '../../elements/Text';
import Icon from '../../elements/Icon';

const NewsletterContainer = (props) => {
  const {
    direction,
    theme,
    componentsConfiguration,
    ui,
    prePopulation,
    integrationSettings,
    meta,
    getAirports = getAirportsFn,
    pageContext,
    translate
  } = props;

  const [className, style] = useStyles(props?.ui, { direction, theme });
  const myStyle = Object.assign({ minHeight: '340px' }, style);

  // const track = useTrackingChange();

  const { subscriptionInfo, uiSettings, match, clearFilters, retry, ...filtersState } = useFilters({
    // const { filtersState, dispatch, match, subscriptionInfo, retry, uiSettings } = useFilters({
    ui,
    filters: ui?.form?.filters,
    prePopulation,
    integrationSettings,
    meta,
    getAirports,
    getSubscription,
    availableFilters: ui?.form?.filters?.availableFilters,
    pageContext
  });

  const callToActionStatus = () => {
    if (match('LOADING')) {
      return 'LOADING';
    } else {
      if (match('COMPLETE')) {
        return 'COMPLETE';
      } else {
        return 'INIT';
      }
    }
  };
  const [showAlert, setShowAlert] = React.useState(false);
  const [userInteract, setUserInteract] = React.useState(false);

  /**
   * This effect is used to hide the alert
   */
  React.useEffect(() => {
    if (subscriptionInfo.success) {
      setShowAlert(true);
      setUserInteract(false);
      setTimeout(() => {
        clearFilters();
        setShowAlert(false);
      }, componentsConfiguration?.closeAlertAfter);
    }
  }, [clearFilters, componentsConfiguration?.closeAlertAfter, subscriptionInfo.success]);

  const content = (
    <>
      {componentsConfiguration?.showAlertInfo && subscriptionInfo.success && showAlert ? (
        <Box {...ui?.alert}>
          <Text>
            {translate('cmp-newsletter-alert-info', 'Success! Thank you for subscribing')}
          </Text>
          <Button
            color="transparent"
            textColor="white"
            display="flex"
            {...ui?.alert?.buttonClose}
            onClick={() => {
              clearFilters();
              setShowAlert(false);
            }}
          >
            <Icon icon={'close'} size={20} {...ui?.alert?.buttonClose?.iconClose} />
          </Button>
        </Box>
      ) : null}
      {match('ERROR') && <ContainerErrorAlert {...ui?.alertError} tryAgain={retry} />}
      <Row {...ui?.rowSettings}>
        <Col {...ui?.contentPrimary}>
          <HeaderContainer
            // handleSeeMoreDeals={handleSeeMoreDeals}
            defaultTitleValue="Suscribe to our newsletter to stay in touch with out flight deals."
            defaultSubtitleValue="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
            {...componentsConfiguration}
            {...ui}
          />
        </Col>
        <Form
          {...filtersState}
          {...uiSettings}
          userInteract={userInteract}
          setUserInteract={setUserInteract}
          isMobile={componentsConfiguration?.isMobile}
          showAlertButton={showAlert}
          showInformation={!componentsConfiguration?.showAlertInfo}
          callToActionStatus={callToActionStatus()}
        />
      </Row>
    </>
  );

  return (
    <Box
      position="relative"
      className={`${className}  ${
        componentsConfiguration?.isMobile
          ? 'NewsletterContainerMobile'
          : NewsletterContainer.componentName
      }`}
      style={myStyle}
      dataTestId="NewsletterContainer"
    >
      {componentsConfiguration?.showSkeletonScreen && filtersState?.locations.origin.isLoading && (
        <Skeleton
          {...ui?.skeletonSettings}
          isMobile={componentsConfiguration?.isMobile}
          position="absolute"
          width="100"
        />
      )}
      {componentsConfiguration?.showBackgroundImage ? (
        <ImageHeader {...ui?.imageContainer}>{content}</ImageHeader>
      ) : (
        content
      )}
    </Box>
  );
};

NewsletterContainer.componentName = 'NewsletterContainer';

export default withCommonEMContainer(NewsletterContainer);
